import React from 'react';
import { RoutineAction } from '../../../models';
import CreateChangeForm from './CreateChangeForm';
import DuplicateChangeForm from './DuplicateChangeForm';
import NotifyForm from './NotifyForm';
import SetStatusForm from './SetStatusForm';
import AssignForm from './AssignForm';
import AssignClientForm from './AssignClientForm';
import MoveBoardForm from './MoveBoardForm';
import {
    AddCommentForm,
    SendEmailForm,
    SetEstimateForm,
    DiscardForm,
} from './SimpleActionForms';

interface ActionFormProps {
    action: RoutineAction;
    onSave?: (action: RoutineAction) => void;
    authorId?: string;
    projectId?: string;
    changeId?: string;
}

function ActionForm(props: ActionFormProps) {
    const { action } = props;

    const form = React.useMemo(() => ({
        'create_change': <CreateChangeForm {...props} />,
        'duplicate_change': <DuplicateChangeForm {...props} />,
        'notify': <NotifyForm {...props} />,
        'notify_unclaimed_changes': (
            <NotifyForm
                {...props}
                defaultTitle="24/7 — [[count]] en attente"
                defaultMessage={"Cartes non claimées :\n[[list]]"}
            />
        ),
        'set_status': <SetStatusForm {...props} />,
        'assign': <AssignForm {...props} />,
        'assign_client': <AssignClientForm {...props} />,
        'move_board': <MoveBoardForm {...props} />,
        'discard': <DiscardForm />,
        'add_comment': <AddCommentForm {...props} />,
        'send_email': <SendEmailForm {...props} />,
        'set_estimate': <SetEstimateForm {...props} />,
    }[action.type]), [action?.type, action?.options, props.projectId]);

    return <>{form}</>;
}

export default ActionForm;
